module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAM1BMVEUAAAAzMzMyMjIzMzMzMzMzMzMzMzMyMjIyMjI0NDQ0NDQxMTEyMjI5OTlAQEAzMzMzMzMQ+0QrAAAAEHRSTlMAiTn22s2+jnZAMS8kCQT0J4dITAAAAFlJREFUOMvtzkkKwCAQRNFyno33P22QoBi0A9kF4tv+gm5s32NE6Q6DCS83/P0Aeuwaszj8ICIWbOksVrJqXWUs+TbwILCrM1CSrF0mkFwdODxg7QApBPzTCUthB0sI2nQkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/longda/down.png
// module id = J9mr
// module chunks = 39